import React, { createRef, FC, ReactNode, useEffect } from 'react';
import MaterialTable, { MaterialTableProps, Components } from 'material-table';
import { Paper } from '@material-ui/core';

import DateCell from '../common/DateCell';
import VideoPlayer from '../common/VideoPlayer';
import { useLanguageContext } from '../languages';
import { DRMTYPE, Period } from '../../utils/types';
import { getLocalTimezone } from '../../utils/dateTransform';

const ClipSelector: FC<ClipSelectorProps> = (props) => {
	const { drmType, laSource, onChange, periods, videoUrl } = props;
	const { tableLocalization } = useLanguageContext();
	const tableRef = createRef<MaterialTableProps<Period>>();

	useEffect(() => {
		return (): void => {
			// eslint-disable-next-line  @typescript-eslint/ban-ts-ignore
			// @ts-ignore
			tableRef?.current?.onAllSelected(false);
		};
	}, [tableRef]);

	const tableColumns = [
		{
			title: 'Title',
			field: 'title'
		},
		{
			title: 'Player',
			field: 'shortText'
		},
		{
			title: `Start Time (${getLocalTimezone()})`,
			field: 'startTime',
			cellStyle: { minWidth: 175 },
			render: (row: Period): JSX.Element => <DateCell value={row.source.startTime ?? ''} showTimezone={false} />
		},
		{
			title: `End Time (${getLocalTimezone()})`,
			field: 'endTime',
			cellStyle: { minWidth: 175 },
			render: (row: Period): JSX.Element => <DateCell value={row.source.endTime ?? ''} showTimezone={false} />
		},
		{
			title: 'Period ID',
			field: 'id'
		},
		{
			title: 'Play ID',
			field: 'playId'
		}
	];

	const tableComponents: Components = {
		Container: (props): JSX.Element => <Paper {...props} data-testid='live-highlight-periods-table' />
	};

	const showPreview = (rowData: Period, source: string): ReactNode => {
		if (drmType && laSource)
			return (
				<VideoPlayer
					drmType={drmType.toLowerCase() as DRMTYPE}
					laSource={laSource}
					source={source}
					timeShift={true}
					videoEnd={rowData?.source?.endTime || ''}
					videoStart={rowData?.source?.startTime || ''}
				/>
			);
		return <VideoPlayer source={source} timeShift={false} videoEnd={rowData?.source?.endTime || ''} videoStart={rowData?.source?.startTime || ''} />;
	};

	return (
		<MaterialTable
			tableRef={tableRef}
			localization={tableLocalization}
			columns={tableColumns}
			options={{
				pageSize: 5,
				search: false,
				sorting: false,
				toolbar: false,
				selection: true
			}}
			data={periods}
			onSelectionChange={onChange}
			components={tableComponents}
			detailPanel={(rowData): ReactNode => showPreview(rowData, videoUrl)}
		/>
	);
};

type ClipSelectorProps = {
	drmType?: DRMTYPE;
	laSource?: string;
	onChange: (periods: Period[]) => void;
	periods: Period[] | [];
	videoUrl: string;
};

export default ClipSelector;
